import pick from 'lodash/pick';
import get from 'lodash/get';
import assign from "lodash/assign";
import { BeeModelCollection } from "./BeeModelCollection";
import parseISO from "date-fns/parseISO";
var BeeModel = /** @class */ (function () {
    function BeeModel(modelManager, record) {
        this.modelManager = modelManager;
        this.related = {};
        this.presented = {};
        this.options = this.modelManager.options;
        assign(this, pick(record, ['presented', 'related']));
        assign(this, record.attributes);
    }
    BeeModel.getCollectionClass = function () {
        return BeeModelCollection;
    };
    BeeModel.prototype.hasOne = function (modelType, relationshipName) {
        if (relationshipName === void 0) { relationshipName = modelType; }
        var relatedId = this.related[relationshipName].value;
        if (!relatedId)
            return null;
        var rawRecords = this.modelManager.getRecordsMap(modelType);
        var rawRecord = rawRecords[relatedId];
        var ModelClass = this.modelManager.getModelClass(modelType);
        return new ModelClass(this.modelManager, rawRecord);
    };
    BeeModel.prototype.hasMany = function (modelType, relationshipName) {
        var _this = this;
        if (relationshipName === void 0) { relationshipName = modelType; }
        var rawRecords = this.related[relationshipName].value.map(function (id) { return _this.modelManager.getRecordsMap(modelType)[id]; });
        return this.modelManager.constructCollection(rawRecords, modelType);
    };
    BeeModel.prototype.belongsToOne = function (modelType, relationshipName) {
        var _this = this;
        if (relationshipName === void 0) { relationshipName = modelType; }
        var rawRecords = this.modelManager.getRawRecords(modelType).filter(function (m) { return m.related[relationshipName].value == _this.id; });
        return this.modelManager.constructCollection(rawRecords, modelType);
    };
    BeeModel.prototype.belongsToMany = function (modelType, relationshipName) {
        var _this = this;
        if (relationshipName === void 0) { relationshipName = modelType; }
        var rawRecords = this.modelManager.getRawRecords(modelType).filter(function (m) { return m.related[relationshipName].value.includes(_this.id); });
        return this.modelManager.constructCollection(rawRecords, modelType);
    };
    BeeModel.prototype.getRaw = function (key) {
        return get(this, key);
    };
    BeeModel.prototype.get = function (key) {
        var value = this.getRaw(key);
        // @ts-ignore
        if (this.constructor.dates.includes(key)) {
            // TODO: take care of different time of the user browser
            return value ? parseISO(value.date) : null;
        }
        // @ts-ignore
        if (this.constructor.times.includes(key)) {
            // TODO: take care of different time of the user browser
            return value ? parseISO("1970-01-01 " + value) : null;
        }
        return value;
    };
    BeeModel.dates = [];
    BeeModel.times = [];
    return BeeModel;
}());
export { BeeModel };
